// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../fetch.pb.js";
export const HydraShell = {
    /**
     * When an authorization code, hybrid, or implicit OAuth 2.0 Flow is
     * initiated, Ory asks the login provider to authenticate the subject and
     * then tell the Ory OAuth2 Service about it.  Per default, the login
     * provider is Ory itself. You may use a different login provider which needs
     * to be a web-app you write and host, and it must be able to authenticate
     * ("show the subject a login screen") a subject (in OAuth2 the proper name
     * for subject is "resource owner").  The authentication challenge is
     * appended to the login provider URL to which the subject's user-agent
     * (browser) is redirected to. The login provider uses that challenge to
     * fetch information on the OAuth2 request and then accept or reject the
     * requested authentication process.
     */
    InitialOAuth2LoginRequest(fn, req) {
        return fn(`/hydra-shell/login/oauth2`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * When an authorization code, hybrid, or implicit OAuth 2.0 Flow is
     * initiated, Ory asks the login provider to authenticate the subject and
     * then tell the Ory OAuth2 Service about it.  The authentication challenge
     * is appended to the login provider URL to which the subject's user-agent
     * (browser) is redirected to. The login provider uses that challenge to
     * fetch information on the OAuth2 request and then accept or reject the
     * requested authentication process.  This endpoint tells Ory that the
     * subject has successfully authenticated and includes additional information
     * such as the subject's ID and if Ory should remember the subject's subject
     * agent for future authentication attempts by setting a cookie.  The
     * response contains a redirect URL which the login provider should redirect
     * the user-agent to.  You can pass a subject in the `cancel` field on the
     * request in order to invalidate existing authentication sessions for the
     * subject.  After revoking the authentication session(s), the subject has to
     * re-authenticate at the Ory OAuth2 Provider. This does not invalidate any
     * tokens.
     */
    AcceptOAuth2LoginRequest(fn, req) {
        return fn(`/hydra-shell/login/oauth2/accept`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * When an authorization code, hybrid, or implicit OAuth 2.0 Flow is
     * initiated, Ory asks the login provider to authenticate the subject and
     * then tell Ory now about it. If the subject authenticated, he/she must now
     * be asked if the OAuth 2.0 Client which initiated the flow should be
     * allowed to access the resources on the subject's behalf.  The consent
     * challenge is appended to the consent provider's URL to which the subject's
     * user-agent (browser) is redirected to. The consent provider uses that
     * challenge to fetch information on the OAuth2 request and then tells Ory if
     * the subject accepted or rejected the request.  The default consent
     * provider is available via the Ory Managed Account Experience. To customize
     * the consent provider, please head over to the OAuth 2.0 documentation.
     */
    InitialOAuth2ConsentRequest(fn, req) {
        return fn(`/hydra-shell/consent/oauth2`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * When an authorization code, hybrid, or implicit OAuth 2.0 Flow is
     * initiated, Ory asks the login provider to authenticate the subject and
     * then tell Ory now about it. If the subject authenticated, he/she must now
     * be asked if the OAuth 2.0 Client which initiated the flow should be
     * allowed to access the resources on the subject's behalf.  The consent
     * challenge is appended to the consent provider's URL to which the subject's
     * user-agent (browser) is redirected to. The consent provider uses that
     * challenge to fetch information on the OAuth2 request and then tells Ory if
     * the subject accepted or rejected the request.  This endpoint tells Ory
     * that the subject has authorized the OAuth 2.0 client to access resources
     * on his/her behalf.  The consent provider includes additional information,
     * such as session data for access and ID tokens, and if the consent request
     * should be used as basis for future requests.  The response contains a
     * redirect URL which the consent provider should redirect the user-agent to.
     * The default consent provider is available via the Ory Managed Account
     * Experience. To customize the consent provider, please head over to the
     * OAuth 2.0 documentation.
     */
    AcceptOAuth2ConsentRequest(fn, req) {
        return fn(`/hydra-shell/consent/oauth2/accept`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Use this endpoint to fetch an Ory OAuth 2.0 logout request.
     */
    InitialOAuth2LogoutRequest(fn, req) {
        return fn(`/hydra-shell/logout/oauth2`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * When a user or an application requests Ory OAuth 2.0 to remove the session
     * state of a subject, this endpoint is used to confirm that logout request.
     * The response contains a redirect URL which the consent provider should
     * redirect the user-agent to.
     */
    AcceptOAuth2LogoutRequest(fn, req) {
        return fn(`/hydra-shell/logout/oauth2/accept`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
